<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Campaigns.category")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialCategoriesWithDescendants
              v-model="materialCategoriesSelected"
            />
          </v-row>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="materialCategoriesDetails"
        :loading="loading"
        :search="filter"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="360px"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <!-- <template v-slot:top>
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <v-spacer />
            <v-row no-gutters class="me-n3">
              <v-spacer />
              <v-col cols="12" sm="9" md="8">
                <v-text-field
                  v-model="filter"
                  clearable
                  hide-details
                  :label="$t('Search.filter')"
                />
              </v-col>
            </v-row>
          </v-toolbar>
          <v-divider />
        </template> -->
        <template v-slot:header.check>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              materialCategoriesDetails.find(
                (detail) => detail.check != checkAll
              )
                ? true
                : false
            "
            v-model="checkAll"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("Role.TemplatePermissionFields.check_all") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.check="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.check"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
            </v-checkbox>
          </div>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          @click="
            $emit(
              'confirm',
              materialCategoriesDetails.filter((d) => d.check)
            );
            dialog = false;
          "
        >
          {{
            $t("CRUD.confirmWithChooseCount", [
              materialCategoriesDetails.length
                ? materialCategoriesDetails.filter((s) => s.check).length
                : 0,
            ])
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import MaterialCategories from "@/api/material_categories";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";

export default {
  name: "DialogCategories",

  components: { SearcherMaterialCategoriesWithDescendants },

  props: {
    value: Boolean,
    categorySelected: Array,
    disabled: Array,
    isNotDisabled: Boolean,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Campaigns.Fields.categories_code"),
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: i18n.t("Campaigns.Fields.categories_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("Role.DistrictPermissionFields.check_all"),
          align: "start",
          sortable: false,
          value: "check",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    materialCategoriesDetails() {
      return this.categories.filter(
        (item) =>
          (this.materialCategoriesSelected.length &&
            this.materialCategoriesSelectedids.indexOf(item.id) >= 0) ||
          !this.materialCategoriesSelected.length
      );
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    showSelected: [],
    filter: "",
    categories: [],
    paging: {},
    itemsPerPageOptions: 10,
    checkAll: 0,
    materialCategoriesSelected: [],
    materialCategoriesSelectedids: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.getCategoriesFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.categories = [];
          this.filter = "";
        }
      },
    },
    checkAll: {
      handler() {
        this.categories = this.categories.map(
          function (detail) {
            if (!detail.disabled) {
              detail.check = this.checkAll ? 1 : 0;
            }
            return detail;
          }.bind(this)
        );
      },
    },
    materialCategoriesSelected: {
      handler() {
        this.materialCategoriesSelectedids = [];
        this.materialCategoriesSelectedids =
          this.getMaterialCategoriesSelectedIds(
            this.materialCategoriesSelected
          );
      },
    },
  },

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    getCategoriesFromAPI() {
      MaterialCategories.fetchAll().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.categories = response.data.categories.map((item) => {
              if (this.categorySelected) {
                this.categorySelected.forEach((selected) => {
                  if (selected.id == item.id) {
                    item.check = 1;
                    if (!this.isNotDisabled) {
                      item.disabled = true;
                    }
                  }
                });
              }
              if (this.disabled) {
                this.disabled.forEach((d) => {
                  if (d == item.id && !this.isNotDisabled) {
                    item.disabled = true;
                  }
                });
              }

              return item;
            });
          }
        }.bind(this)
      );
    },

    // 查询分类
    getMaterialCategoriesSelectedIds(item, ids = []) {
      item.forEach((e) => {
        ids.push(e.id);
      });
      return ids;
    },
  },
};
</script>
